<template>
  <button
    class="theme-toggle"
    type="button"
    :aria-label="label"
    :title="label"
    @click="toggleTheme"
  >
    <i
      class="theme-toggle__icon zmdi"
      :class="isDark ? 'zmdi-brightness-5' : 'zmdi-brightness-3'"
    />
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useTheme } from '@/composables/useTheme'

const { isDark, toggleTheme } = useTheme()
const { t } = useI18n()

const label = computed(() =>
  isDark.value ? t('theme.switchToLight') : t('theme.switchToDark'),
)
</script>

<style scoped lang="scss">
.theme-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
   width: 44px;
   height: 44px;
  border-radius: var(--p-radius-50);
  border: 1px solid var(--ds-border);
  background: var(--ds-surface-raised);
  color: var(--ds-text-secondary);
  cursor: pointer;
  transition:
    background var(--p-motion-base) var(--p-ease),
    color var(--p-motion-base) var(--p-ease),
    border-color var(--p-motion-base) var(--p-ease);

  &:hover {
    background: var(--ds-accent-soft);
    color: var(--ds-accent);
    border-color: var(--ds-accent);
  }

  &:focus-visible {
    box-shadow: var(--ds-focus-ring-shadow);
    outline: none;
  }

  &__icon {
    font-size: var(--ds-text-size-h-sm);
    line-height: 1;
  }
}
</style>
